/**
 * Which product this app is. Matches products.id in the database and the
 * folder under products/. Every platform query and function call names it.
 */
export const PRODUCT_ID = 'lowfodmaps'

/** The display name, filled into every `{brand}` placeholder. */
export const PRODUCT_NAME = 'LowFodmaps'

/** Shown until the products row loads; products.trial_days is what Checkout applies. */
export const TRIAL_DAYS = 7

/**
 * LowFodmaps's terms and privacy policy, on its landing (products/lowfodmaps/landing/
 * legal.<locale>.json, rendered by the landing kit). Must match `landing` in
 * products/lowfodmaps/product.json: origin + basePath, Portuguese under `pt/`.
 */
const LANDING_URL = 'https://mudacorp.com/lowfodmaps/'

export function legalUrls(locale: string): { terms: string; privacy: string } {
  const base = locale === 'pt' ? `${LANDING_URL}pt/` : LANDING_URL
  return { terms: `${base}terms/`, privacy: `${base}privacy/` }
}
